module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copy",
    attrs: {
      "id": "copy"
    }
  }, [_c('h2', {
    staticClass: "copyHead"
  }, [_vm._v("ebook ISBN: 978-1-56037-534-0")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara1"
  }, [_vm._v("print book ISBN: 978-1-56037-198-4")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara1"
  }, [_vm._v("First edition published by the author, 1900.")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara"
  }, [_vm._v("© 2001 by Farcountry Press")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara"
  }, [_vm._v("1, 2012")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara"
  }, [_vm._v("Cover photos: Mountain scene by John Lambing; Piegan chiefs and headmen from the Eleventh Census of the United States, 1890.")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara2"
  }, [_vm._v("Spelling, typography, and grammar have been preserved from the first edition, although correct spellings are used in the index.")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara"
  }, [_vm._v("Photographs from the first edition were included if modern prints were available; otherwise, similar images were substituted.")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara2"
  }, [_vm._v("This book may not be reproduced in whole or in part by any means (with the exception of short quotes for the purpose of review) without the permission of the publisher.")]), _vm._v(" "), _c('h2', {
    staticClass: "copypara"
  }, [_vm._v("For more information on our books, write"), _c('br'), _vm._v(" Farcountry Press, P.O. Box 5630, Helena, MT 59604;"), _c('br'), _vm._v(" call (800) 821-3874; or visit "), _c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "http://www.farcountrypress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.farcountrypress.com")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a517665","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_ThenandNowbook_copyright.vue
// module id = 66
// module chunks = 0